import React from "react";
import { useTranslation } from "react-i18next";
// import { useSelector } from "react-redux";
import { Outlet } from "react-router-dom";
import NestedTabsComponent from "../nested-tabs-component";
import { SITE_SETTINGS_TYPE, NESTED_SIDENAV, ACCESS_CONFIG } from "../strings";

const SiteSettings = () => {
  const { t } = useTranslation();
  const { ONLY_SUPER_ADMIN } = ACCESS_CONFIG;

  return (
    <div className="d-flex h-100">
      <div className="sub-sidebar">
        <div className="inner-sub-sidebar">
          <div className="tab-heading ps-3 mt-4">
            {t("sidebar.siteSettings")}
          </div>
          <NestedTabsComponent
            nestedNavType={NESTED_SIDENAV.SITE_SETTINGS}
            clearParams
            tabs={[
              {
                evKey: SITE_SETTINGS_TYPE.FACEBOOK_ACCOUNTS,
                title: "Facebook Accounts",
                access: ONLY_SUPER_ADMIN
              },
              {
                evKey: SITE_SETTINGS_TYPE.FORM_DEFAULTS,
                title: t("formDefaults.title"),
                access: ONLY_SUPER_ADMIN
              },
              {
                evKey: SITE_SETTINGS_TYPE.COUNTRIES,
                title: t("countries.title"),
                access: ONLY_SUPER_ADMIN
              }
            ]}
          />
        </div>
      </div>
      <div className="outlet-wrapper">
        <Outlet />
      </div>
    </div>
  );
};
export default SiteSettings;
